<template>
    <div class="guidance_test">
        <div v-if="isOpenGuiDance == ''">
            <div class="cjkTopBtnBox">
                <div class="cjkTopwdrczx">
                    <div class="cjkTopwdrczxImg">
                        <img :src="imgObj.icon_wdrczx" alt="" />
                    </div>
                    <div class="cjkTopwdrczxText">
                        <span>我的日常咨询</span>
                    </div>
                </div>
                <div class="cjkTopwdjjfa">
                    <div class="cjkTopwdjjfaImg">
                        <img :src="imgObj.icon_wdjjfa" alt="" />
                    </div>
                    <div class="cjkTopwdjjfaText">
                        <span>我的检测报告</span>
                    </div>
                </div>
            </div>
            <div class="cjkTopCheckBox">
                <div class="cjkTopCheckLeft">
                    <div class="cjkLeftTop">
                        <div class="cjkLeftTopTitle">稽查应急问</div>
                        <div class="cjkLeftTopListBox">
                            <div class="cjkLeftTopList" @click="jcyjwClick('jcyjw',0)">税干问</div>
                            <div class="cjkLeftTopList" @click="jcyjwClick('jcyjw',1)">会计问</div>
                            <div class="cjkLeftTopList" @click="jcyjwClick('jcyjw',2)">老板问</div>
                        </div>
                    </div>
                    <div class="cjkLeftBottom">
                        <div class="cjkLeftBottomLeft" @click="jcyjwClick('rdw',1)">热点预警</div>
                        <div class="cjkLeftBottomRight" @click="jcyjwClick('ydw',2)">引导问</div>
                    </div>
                </div>
                <div class="cjkTopCheckRight">
                    <div class="cjkTopRightList1" @click="jcbgClick('风险检测',0)">风险检测</div>
                    <!-- <div class="cjkTopRightList2" @click="jcbgClick('补贴检测',1)">补贴检测</div> -->
                    <div class="cjkTopRightList1" @click="jcbgClick('优惠报告',2)">优惠报告</div>
                    <div class="cjkTopRightList2" @click="jcbgClick('项目报告',3)">项目报告</div>
                </div>
            </div>
        </div>
        <div v-if="isOpenGuiDance == 'guidance'">
            <!--日常咨询内容-->
            <div class="guidanceView">
                <!--顶部名称-->
                <div class="topNav">
                    <img class="topNavIcon" :src="imgObj.icon_wdrczx" alt="">
                    <span>我的日常咨询</span>
                </div>
                <div class="bottomShow">
                    <!--顶部的分类-->
                    <div class="guidanceTop">
                        <div v-for="(item,index) in guiDanceArr" :key="index">
                            <div 
                                @click="guiDanceArrClick(item,index)" 
                                :class="guiDanceArrIndex == index?'guidanceListCheck':''"
                                class="guidanceList">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="guidancetopBorder"></div>
                    </div>
                    <!--根据顶部分类展示的子级内容-->
                    <div class="guidanceChild">
                        <div v-show="guiDanceArrIndex == 0">
                            <div class="jcyjwChildTop">
                                <div 
                                    class="jcyjwChildList"
                                    :class="jcyjwChildIndex== index ?'jcyjwChildListCheck':''"
                                    v-for="(item,index) in guiDanceArr[0].child"
                                    :key="index"
                                    @click="jcyjwChildClick(item,index)">
                                    {{ item.name }}
                                </div>
                            </div>
                            <div v-show="jcyjwChildIndex==0">
                                <!--最新稽查案例 列表-->
                                <div class="centerContent" v-if="isOpenGuiDance == 'guidance'">
                                    <!--没稳过问题就显示最新稽查案例-->
                                    <div v-if="shuiganList.length==0">
                                        <inspectView  ref="inspectView" />
                                    </div>
                                    <div class='sseBigBox' v-show="shuiganList.length!=0">
                                        <div v-for="(item,index) in shuiganList" :key="index">
                                            <jczdSSEView ref="jczdSSEView" :tIndez="index" :sendSEEObj="item" />
                                        </div>
                                    </div>
                                </div>
                                <!--输入框-->
                                <div class="userTextView" v-if="isOpenGuiDance == 'guidance'">
                                    <div class="userTextTop">
                                        <el-input
                                            type="textarea"
                                            :rows="4"
                                            :maxlength=1000
                                            placeholder="请输入您想咨询的问题，每次提问都将开启一次新的对话噢~"
                                            v-model="wentiUserText">
                                        </el-input>
                                    </div>
                                    <div class="userTextBottom">
                                        <div class="userTextNum">
                                            <p>{{ wentiUserText.length }}/1000</p>
                                        </div>
                                        <div class="userTextBtn">
                                            <div class="userTextBtnClear" @click="userTextClear"><text class="iconfont">&#xe8af;</text>重置</div>
                                            <div class="userTextBtnSubmit" @click="userTextSubmit">诊断</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="jcyjwChildIndex==1">
                                <!--最新稽查案例 列表-->
                                <div class="centerContent" v-if="isOpenGuiDance == 'guidance'">
                                    <!--没稳过问题就显示最新稽查案例-->
                                    <div v-if="kuaijiList.length==0">
                                        <inspectView  ref="inspectView" />
                                    </div>
                                    <div class='sseBigBox' v-show="kuaijiList.length!=0">
                                        <div v-for="(item,index) in kuaijiList" :key="index">
                                            <jczdSSEView ref="jczdSSEView" :tIndez="index" :sendSEEObj="item" />
                                        </div>
                                    </div>
                                </div>
                                <!--输入框-->
                                <div class="userTextView" v-if="isOpenGuiDance == 'guidance'">
                                    <div class="userTextTop">
                                        <el-input
                                            type="textarea"
                                            :rows="4"
                                            :maxlength=1000
                                            placeholder="请输入您想咨询的问题，每次提问都将开启一次新的对话噢~"
                                            v-model="wentiUserText">
                                        </el-input>
                                    </div>
                                    <div class="userTextBottom">
                                        <div class="userTextNum">
                                            <p>{{ wentiUserText.length }}/1000</p>
                                        </div>
                                        <div class="userTextBtn">
                                            <div class="userTextBtnClear" @click="userTextClear"><text class="iconfont">&#xe8af;</text>重置</div>
                                            <div class="userTextBtnSubmit" @click="userTextSubmit">诊断</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="jcyjwChildIndex==2">
                                <!--最新稽查案例 列表-->
                                <div class="centerContent" v-if="isOpenGuiDance == 'guidance'">
                                    <!--没稳过问题就显示最新稽查案例-->
                                    <div v-if="laobanList.length==0">
                                        <inspectView  ref="inspectView" />
                                    </div>
                                    <div class='sseBigBox' v-show="laobanList.length!=0">
                                        <div v-for="(item,index) in laobanList" :key="index">
                                            <jczdSSEView ref="jczdSSEView" :tIndez="index" :sendSEEObj="item" />
                                        </div>
                                    </div>
                                </div>
                                <!--输入框-->
                                <div class="userTextView" v-if="isOpenGuiDance == 'guidance'">
                                    <div class="userTextTop">
                                        <el-input
                                            type="textarea"
                                            :rows="4"
                                            :maxlength=1000
                                            placeholder="请输入您想咨询的问题，每次提问都将开启一次新的对话噢~"
                                            v-model="wentiUserText">
                                        </el-input>
                                    </div>
                                    <div class="userTextBottom">
                                        <div class="userTextNum">
                                            <p>{{ wentiUserText.length }}/1000</p>
                                        </div>
                                        <div class="userTextBtn">
                                            <div class="userTextBtnClear" @click="userTextClear"><text class="iconfont">&#xe8af;</text>重置</div>
                                            <div class="userTextBtnSubmit" @click="userTextSubmit">诊断</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--最新稽查案例 列表-->
                            <!-- <div class="centerContent" v-if="isOpenGuiDance == 'guidance'">
                                <div v-if="isShowSSE == false">
                                    <inspectView  ref="inspectView" />
                                </div>
                                <div v-if="isShowSSE == true">
                                    <jczdSSEView ref="jczdSSEView" :sendSEEObj="sendSEEObj" />
                                </div>
                            </div>
                            <div class="userTextView" v-if="isOpenGuiDance == 'guidance'">
                                <div class="userTextTop">
                                    <el-input
                                        type="textarea"
                                        :rows="4"
                                        :maxlength=1000
                                        placeholder="请输入您想咨询的问题，每次提问都将开启一次新的对话噢~"
                                        v-model="wentiUserText">
                                    </el-input>
                                </div>
                                <div class="userTextBottom">
                                    <div class="userTextNum">
                                        <p>{{ wentiUserText.length }}/1000</p>
                                    </div>
                                    <div class="userTextBtn">
                                        <div class="userTextBtnClear" @click="userTextClear"><text class="iconfont">&#xe8af;</text>重置</div>
                                        <div class="userTextBtnSubmit" @click="userTextSubmit">诊断</div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="guiDanceArrIndex == 1">
                            <!--热点-->
                            <categoryViewRD v-show="isShowCategoryRD&&isShowSSE == false" :sendDataCode="sendDataCode" />
                            <!--展示sse-->
                            <div v-if="isShowSSE == true">
                                <jczdSSEView ref="jczdSSEView" :sendSEEObj="sendSEEObj" />
                            </div>
                        </div>
                        <div v-if="guiDanceArrIndex == 2">
                            <!--引导-->
                            <categoryViewYD v-show="isShowCategoryYD&&isShowSSE == false" :sendDataCode="sendDataCode" />
                            <div v-if="isShowSSE == true">
                                <jczdSSEView ref="jczdSSEView" :sendSEEObj="sendSEEObj" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--压缩的 检测报告-->
            <div class="smallTestView">
                <div class="topNav">
                    <img class="topNavIcon" :src="imgObj.icon_wdjjfa" alt="">
                    <span>我的检测报告</span>
                </div>
                <div class="smallTestListView">
                    <div class="smallTestList" @click="jcbgClick('风险检测',0)">风险检测</div>
                    <!-- <div class="smallTestList" @click="jcbgClick('补贴检测',1)">补贴检测</div> -->
                    <div class="smallTestList" @click="jcbgClick('优惠报告',2)">优惠报告</div>
                    <div class="smallTestList" @click="jcbgClick('项目报告',3)">项目报告</div>
                </div>
            </div>
        </div>
        <!--检测报告-->
        <div v-if="isOpenGuiDance == 'test'">
            <!--压缩的我的日常咨询-->
            <div class="smallRCZXView">
                <div class="topNav">
                    <img class="topNavIcon" :src="imgObj.icon_wdjjfa" alt="">
                    <span>我的日常咨询</span>
                </div>
                <div class="smallRCZXListView">
                    <div class="smallRCZXLeft">
                        <div class="smallRCZXLeftName">稽查应急问</div>
                        <div class="smallRCZXLeftChild">
                            <div class="smallRCZXLeftList" @click="jcyjwClick('jcyjw',0)">税干问</div>
                            <div class="smallRCZXLeftList" @click="jcyjwClick('jcyjw',1)">会计问</div>
                            <div class="smallRCZXLeftList" @click="jcyjwClick('jcyjw',2)">老板问</div>
                        </div>
                    </div>
                    <div class="smallRCZXRight">
                        <div class="smallRCZXRightList" @click="jcyjwClick('rdw',1)">热点预警</div>
                        <div class="smallRCZXRightList" @click="jcyjwClick('ydw',2)">引导问</div>
                    </div>
                </div>
            </div>
            <div class="testView">
                <div class="topNav">
                    <img class="topNavIcon" :src="imgObj.icon_wdjjfa" alt="">
                    <span>我的检测报告</span>
                </div>
                <div class="testContent">
                    <!--分类-->
                    <div class="testListBox">
                        <div 
                            class="testNavList"
                            v-for="(item,index) in testTypeList" 
                            v-if="item.name!='补贴检测'"
                            :key="index"
                            @click="testNavListClick(index)"
                            :class="testTypeIndex==index?'testNavListCheck':''">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="testListBorder"></div>
                    <!--风险检测(0)-->
                    <div v-if="testTypeIndex == 0">
                        <fxjcView />
                    </div>
                    <!--补贴检测(1)-->
                    <div v-if="testTypeIndex == 1">
                        <btbgView />
                    </div>
                    <!--优惠报告(2)-->
                    <div v-if="testTypeIndex == 2">
                        <!--简介 -->
                        <ssyhAView :sendData="sendYHBG" />
                    </div>
                    <!--项目报告(3)-->
                    <div v-if="testTypeIndex == 3">
                        <!--简介 -->
                        <ssyhBView :sendData="sendXMBG" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { sseHistory } from '@/api/api.js'
//引入图片
import icon_wdjjfa from '@/assets/images/swjcw/jcbg.png'
import icon_wdrczx from '@/assets/wdrczx.png'

//引入模块
import inspectView from './newInspect/newInspect.vue'
import jczdSSEView from '../jwzdSSE/index.vue'
import categoryViewYD from './categoryView.vue'
import categoryViewRD from './categoryView.vue'
import btbgView from "./btbg/index.vue"
import fxjcView from "./fxjc/index.vue"
import ssyhAView from "./ssyh/index.vue"
import ssyhBView from "./ssyh/index.vue"

 

export default {
    name:'',
    components:{
        inspectView,
        jczdSSEView,
        categoryViewYD,
        categoryViewRD,
        btbgView,
        fxjcView,
        ssyhAView,
        ssyhBView
    },
    data(){
        return{
            //图片地址
            imgObj: {
                icon_wdjjfa,
                icon_wdrczx,
            },
            //展示的分类模块
            isOpenGuiDance:'',
            //日常咨询的分类
            guiDanceArr:[
                {
                    name:'稽查应急问',
                    code:'',
                    collectionCode:'aiw-jcyjw',
                    child:[
                        {
                            name:'税干问',
                            sseCode:'sgw',
                        },
                        {
                            name:'会计问',
                            sseCode:'cwryw',
                        },
                        {
                            name:'老板问',
                            sseCode:'lbgdw',
                        }
                    ]
                },
                {
                    name:'热点预警',
                    code:'rdw',
                    collectionCode:'aiw-rdyj',
                },
                {
                    name:'引导问',
                    code:'ydw',
                    collectionCode:'aiw-ydw',
                },
            ],
            //检测的几个分类 
            testTypeList:[
                {
                    name:'风险检测',
                    id:0,
                },
                {
                    name:'补贴检测',
                    id:1,
                },
                {
                    name:'优惠报告',
                    id:2,
                },
                {
                    name:'项目报告',
                    id:3,
                }
            ],
            //检测的几个分类 选中索引
            testTypeIndex:0,
            guiDanceArrIndex:0,
            jcyjwChildIndex:0,
            //是否展示请求sse的
            isShowSSE:false,
            //输入框
            wentiUserText:'',
            //是否正在sse
            isSSEing:false,
            //传给sse的数据
            sendSEEObj:{
                markdownH:'230px',
            },
            //税干问
            shuiganList:[],
            kuaijiList:[],
            laobanList:[],
            sendSEEObjZZZ:{},
            //收藏分类
            collectionType:'aiw-jcyjw',
            //sse类型
            sseCode:'sgw',
            sendDataCode:'rdw',
            isShowCategoryRD:true,
            isShowCategoryYD:true,
            //优惠报告
            sendYHBG:{
                type:'yhbg'
            },
            //项目报告
            sendXMBG:{
                type:'xmbg'
            }
            
        }
    },
    created(){

    },
    mounted(){
        this.getTodaySSE()
    },
    methods:{
        //我的日常咨询分类 稽查应急问的几个点击
        jcyjwClick(key,index){
            //console.log(key)
            //展示稽查应急问的形状
            this.isOpenGuiDance = 'guidance';
            if(key!='jcyjw'){
                let tItem = this.guiDanceArr[index]
                this.guiDanceArrClick(tItem,index)
            }else{
                this.guiDanceArrIndex = 0;
                //选择的分类 高亮 
                this.jcyjwChildIndex = index
                //获取子级内容
                let item = this.guiDanceArr[0].child[index]
                this.jcyjwChildClick(item,index)
            }
            
        },
        //检测报告的小入口
        jcbgClick(key,index){
            //this.$message('应急稽查问--' + key)

            //展示稽查应急问的形状 test
            this.isOpenGuiDance = 'test';

            //调用点击事件
            this.testNavListClick(index)
        },
        //小一点的检测报告点击
        smallJcbgClick(){
            //展示稽查应急问的形状
            this.isOpenGuiDance = 'test';
        },
        //日常咨询的分类切换 稽查应急问 热点预警 引导问 
        guiDanceArrClick(item,index){
            //展示稽查应急问的形状
            this.isOpenGuiDance = 'guidance';

            //切换分类时判断是否在sse 
            if(this.isSSEing == true){
                //提示 先关闭sse再进行分类切换
                this.$message({
                    message:"您有问题正在解答~",
                    type:'warning',
                })
                return
                //子组件的方法
                console.log('关闭sse')
            }
            
            //关闭sse 展示最新稽查
            this.isShowSSE = false;
            //选中高亮
            this.guiDanceArrIndex = index;
            //重置 稽查应急问的选中 
            this.jcyjwChildIndex = 0
            //收藏分类的切换
            this.collectionType = item.collectionCode;
            //
            this.sendDataCode = item.code
            this.isShowCategoryRD = true;
            this.isShowCategoryYD = true;
        },
        //稽查应急问子级选择 (税干问,会计问,老板问)
        jcyjwChildClick(item,index){
            //展示稽查应急问的形状
            this.isOpenGuiDance = 'guidance';
            //切换分类时判断是否在sse 
            if(this.isSSEing == true){
                //提示 先关闭sse再进行分类切换
                this.$message({
                    message:"您有问题正在解答",
                    type:'warning',
                })
                return
                //子组件的方法
                console.log('关闭sse')
            }

            //索引高亮选中
            this.jcyjwChildIndex = index;
            //获取sseCode
            this.sseCode = item.sseCode;
            //输入框的清空
            this.wentiUserText = '';

            //刷新最新稽查数据
            if(this.$refs.inspectView){
                this.$refs.inspectView.refreshData();
            }
        },
        //问题诊断的 重置
        userTextClear(){
            this.wentiUserText = '';
        },
        //
        userTextSubmit(){
            this.sendSEEObj.markdownH = '230px';
            if(this.wentiUserText.trim() == ''){
                this.$message({
                    message:"您还没有输入您想咨询的内容~",
                    type:'warning',
                })
                return
            }


            this.startSSE(this.wentiUserText,this.sseCode,this.collectionType,'more')
        },
        //获取记录
        getTodaySSE(){
            //获取对应的存储
            // let getList = window.sessionStorage.getItem(this.tTypeKey);
            // if(getList&&getList.length!=0){
            //     console.log('正常获取')
            //     getList = JSON.parse(getList)
            // }else{
            //     getList = [];
            // }
            /*let data = {
                entity:{
                    aiCode:'sgw',
                    sessionId:'af97f0c3daeb4f839a864ce3a26d9466',
                    session:'af97f0c3daeb4f839a864ce3a26d9466',
                },
                orders:[
                    {
                        asc:true,
                        column:'create_time'
                    },
                ],
                pageNo:1,
                pageSize:10,
            }
            
            sseHistory(data).then(res => {
                console.log(res)
            })*/
        },


        //sse的准备工作
        startSSE(text,sCode,cCode,type){
            //debugger
             //是否展示中
             if(this.isShowSSE&&!type){
                if(this.isSSEing == true){
                    //提示 先关闭sse再进行分类切换
                    this.$message({
                        message:"您有问题正在解答",
                        type:'warning',
                    })
                    return
                }
                //关闭在打开
                this.isShowSSE = false;
            }

            if(type){
                //问题
                this.sendSEEObjZZZ.quesition = text;
                //所属类型
                this.sendSEEObjZZZ.sseCode = sCode;
                //收藏类型
                this.sendSEEObjZZZ.collectionType = cCode;

                //添加数组
                if(this.jcyjwChildIndex == 0){
                    this.sendSEEObjZZZ.tType = 'shuigan';
                    //所属分类和对应的下标
                    this.shuiganList.push(this.sendSEEObjZZZ)
                }
                if(this.jcyjwChildIndex == 1){
                    this.sendSEEObjZZZ.tType = 'kuaiji';
                    //所属分类和对应的下标
                    this.kuaijiList.push(this.sendSEEObjZZZ)
                }
                if(this.jcyjwChildIndex == 2){
                    this.sendSEEObjZZZ.tType = 'laoban';
                    //所属分类和对应的下标
                    this.laobanList.push(this.sendSEEObjZZZ)
                }
            }else{
                //问题
                this.sendSEEObj.quesition = text;
                //所属类型
                this.sendSEEObj.sseCode = sCode;
                //收藏类型
                this.sendSEEObj.collectionType = cCode;
            }

            //展示
            setTimeout(() => {
                this.isShowSSE = true;
            },50)
        },
        //日常咨询 热点预警 引导问回传
        categoryViewFN(text,sCode){
            this.sendSEEObj.markdownH = '405px';
            if(sCode == 'rdw'){
                this.isShowCategoryRD = false;
            }else{
                this.isShowCategoryYD = false;
            }
            //问题
            this.sendSEEObj.sseTypeName ='解答';
            this.startSSE(text,sCode,this.collectionType)
        },
        //sse里面的回传
        jczdCloseSSE(){
            this.isShowSSE = false;
            this.isShowCategoryRD = true;
            this.isShowCategoryYD = true;
        },
        //检测的子分类点击
        testNavListClick(index){
            //选择的是当前的么 
            if(this.jczdTypeIndex == index){
                return
            }
            
            //选中的
            this.testTypeIndex = index;
            
        },

    }
}
</script>
<style scoped lang="scss">
    .cjkTopBtnBox {
        width: 100%;
        height: 100px;
        .cjkTopwdrczx {
            width: 415px;
            height: 100px;
            float: left;
            background: #0f59a4;
            box-sizing: border-box;
            padding: 25px 0 25px 70px;
            .cjkTopwdrczxImg {
                width: 90px;
                height: 50px;
                float: left;
                img {
                    width: 50px;
                    height: 50px;
                }
            }
            .cjkTopwdrczxText {
                float: left;
                width: 240px;
                height: 50px;
                line-height: 50px;
                font-size: 28px;
                color: #ffffff;
            }
        }
        .cjkTopwdjjfa {
            width: 415px;
            height: 100px;
            float: left;
            margin-left: 20px;
            background: #0f59a4;
            box-sizing: border-box;
            padding: 27px 0 27px 70px;
            .cjkTopwdjjfaImg {
                width: 90px;
                height: 46px;
                float: left;
                img {
                    width: 50px;
                    height: 46px;
                }
            }
            .cjkTopwdjjfaText {
                float: left;
                width: 240px;
                height: 46px;
                line-height: 46px;
                font-size: 28px;
                color: #ffffff;
            }
        }
    }
    .cjkTopCheckBox {
        width: 100%;
        height: 194px;
        -webkit-user-select: none;
        .cjkTopCheckLeft {
            float: left;
            width: 415px;
            overflow: hidden;
            box-sizing: border-box;
            background: #ffffff;
            padding:15px 20px 25px 20px;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
            .cjkLeftTop{
                width:100%;
                height: 95px;
                background: #EEF8FF;
                overflow: hidden;
                box-sizing: border-box;
                .cjkLeftTopTitle{
                    width:100%;
                    height:24px;
                    line-height: 24px;
                    text-align: center;
                    margin-top:5px;
                    font-weight: 700;
                    font-size: 22px;
                    color: #0F59A4;
                }
                .cjkLeftTopListBox{
                    width:100%;
                    height: 40px;
                    margin-top:15px;
                    .cjkLeftTopList{
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        text-align:center;
                        background: #F8F8F8;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        border-radius: 23px ;
                        font-size: 18px;
                        color: #3D3D3D;
                        cursor:pointer;
                        margin-left:18px;
                        float:left;
                    }
                }
            }
            .cjkLeftBottom{
                width:100%;
                height:45px;
                line-height:45px;
                margin-top:14px;
                font-weight: 400;
                font-size: 22px;
                color: #0F59A4;
                text-align: center;
                .cjkLeftBottomLeft{
                    width: 170px;
                    height: 45px;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    float:left;
                    cursor: pointer;
                }
                .cjkLeftBottomRight{
                    width: 170px;
                    height: 45px;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    float:left;
                    margin-left:35px;
                    cursor: pointer;
                }
            }
        }
        .cjkTopCheckRight {
            width: 415px;
            height: 194px;
            background: #ffffff;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
            margin-left: 20px;
            float: left;
            .cjkTopRightList1{
                width: 150px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                cursor:pointer;
                float:left;
                margin-left:40px;
                margin-top:40px;
                font-weight: 400;
                font-size: 22px;
                color: #0F59A4;
            }
            .cjkTopRightList2{
                width: 150px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                cursor:pointer;
                float:left;
                margin-left:35px;
                margin-top:40px;
                font-weight: 400;
                font-size: 22px;
                color: #0F59A4;
            }
        }
    }



    /***日常咨询内容 start */
    .guidanceView{
        width:100%;
        overflow: hidden;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        .topNav{
            width: 850px;
            height: 100px;
            line-height: 100px;
            background: #0F59A4;
            font-weight: 700;
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            .topNavIcon{
                width: 40px;
                height: 45px;
                position: relative;
                top:14px;
                margin-right:20px;
            }
        }
        .bottomShow{
            width:100%;
            min-height: 670px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding:20px;
            .guidanceTop{
                width:100%;
                height:48px;
                overflow: hidden;
                .guidanceListCheck{
                    background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%)!important;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2)!important;
                    color:#ffffff!important;
                }
                .guidanceList{
                    width: 148px;
                    height: 45px;
                    line-height: 45px;
                    font-size: 20px;
                    text-align: center;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    float:left;
                    margin-right:18px;
                    color:#0F59A4;
                    cursor:pointer;
                }
                .guidancetopBorder{
                    width:100%;
                    height:3px;
                    background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%)!important;
                    margin-top:45px;
                }
            }
            .guidanceChild{
                width:100%;
                overflow: hidden;
                padding-bottom: 5px;
                .jcyjwChildTop{
                    width: 810px;
                    height: 60px;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    box-sizing: border-box;
                    padding-top:10px;
                    .jcyjwChildListCheck{
                        background: #0F59A4!important;
                        color:#ffffff!important;
                    }
                    .jcyjwChildList{
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color:#3D3D3D;
                        background: #F8F8F8;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        border-radius: 23px 23px 23px 23px;
                        float:left;
                        margin-left:18px;
                        font-size: 18px;
                        cursor:pointer;
                    }
                }
                .sseBigBox{
                    width: 820px;
                    /*height:360px;*/
                    height:410px;
                    overflow-y: auto;
                    overflow-x: hidden;
                    box-sizing: border-box;
                    padding-bottom:10px;
                }
                .centerContent{
                    width: 810px;
                    /*height:360px;*/
                    height:410px;
                }
                .userTextView{
                    width:100%;
                    height:180px;
                    box-sizing: border-box;
                    border-top:1px solid #D8D8D8;
                    .userTextTop{
                        width:100%;
                        height:120px;
                        box-sizing: border-box;
                        padding: 14px 0;
                        overflow: hidden;
                    }
                    ::v-deep .el-textarea >.el-textarea__inner{
                        border: 0px solid #DCDFE6!important;
                    }
                    .userTextBottom{
                        width:100%;
                        height:45px;
                        .userTextNum{
                            width:590px;
                            height:45px;
                            float:left;
                            p{
                                width:100%;
                                height: 24px;
                                font-family: Source Han Sans, Source Han Sans;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8C8C8C;
                                line-height: 24px;
                                margin-top:20px;
                            }
                        }
                        .userTextBtn{
                            width:calc(100% - 590px);
                            height:45px;
                            float:left;
                            .userTextBtnClear{
                                width: 100px;
                                height: 45px;
                                line-height: 45px;
                                text-align: center;
                                background: #EEF8FF;
                                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                                float:left;
                                margin-left:10px;
                                font-size: 20px;
                                color: #8C8C8C;
                                cursor:pointer;
                            }
                            .userTextBtnSubmit{
                                width: 100px;
                                height: 45px;
                                line-height: 45px;
                                text-align: center;
                                background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%);
                                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                                float:left;
                                margin-left:10px;
                                font-size: 20px;
                                color: #FFFFFF;
                                cursor:pointer;
                            }
                        }
                    }
                }
            }
        }
        
    }
    .smallTestView{
        width:100%;
        margin-top:20px;
        .topNav{
            width: 850px;
            height: 100px;
            line-height: 100px;
            background: #0F59A4;
            font-weight: 700;
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            .topNavIcon{
                width: 40px;
                height: 45px;
                position: relative;
                top:14px;
                margin-right:20px;
            }
        }
        .smallTestListView{
            width:100%;
            height: 85px;
            background: #FFFFFF;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            box-sizing: border-box;
            padding:20px 40px;
            .smallTestList{
                width:calc(25% - 40px);
                height: 45px;
                line-height: 45px;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                float:left;
                margin:0 20px;
                cursor:pointer;
                text-align: center;
                font-weight: 400;
                font-size: 22px;
                color: #0F59A4;
            }
        }
        
    }
    /***日常咨询内容 end */


    /** 我的检测报告 start */
    .testView{
        width:100%;
        overflow: hidden;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        .topNav{
            width: 850px;
            height: 100px;
            line-height: 100px;
            background: #0F59A4;
            font-weight: 700;
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            .topNavIcon{
                width: 40px;
                height: 45px;
                position: relative;
                top:14px;
                margin-right:20px;
            }
        }
    }

    .smallRCZXView{
        width:100%;
        margin-top:20px;
        .topNav{
            width: 850px;
            height: 100px;
            line-height: 100px;
            background: #0F59A4;
            font-weight: 700;
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            .topNavIcon{
                width: 40px;
                height: 45px;
                position: relative;
                top:14px;
                margin-right:20px;
            }
        }
        .smallRCZXListView{
            width:100%;
            height: 85px;
            background: #FFFFFF;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            box-sizing: border-box;
            padding:20px 20px;
            margin-bottom:20px;
            .smallRCZXLeft{
                width:calc(100% - 332px);
                height:45px;
                float:left;
                background: #EEF8FF;
                .smallRCZXLeftName{
                    width:calc(100% - 354px);
                    height:45px;
                    line-height: 45px;
                    float:left;
                    text-align: right;
                    font-weight: 700;
                    font-size: 20px;
                    color: #0F59A4;
                }
                .smallRCZXLeftChild{
                    width:354px;
                    height:45px;
                    float:left;
                    .smallRCZXLeftList{
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background: #F8F8F8;
                        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                        border-radius: 23px;
                        font-size: 18px;
                        color: #3D3D3D;
                        cursor: pointer;
                        margin-left: 18px;
                        float: left;
                        margin-top:1px;
                    }
                }
            }
            .smallRCZXRight{
                width:332px;
                height:45px;
                float:left;
                .smallRCZXRightListcheck{
                    background: #0F59A4!important;
                    color:#ffffff!important;
                }
                .smallRCZXRightList{
                    width:148px;
                    margin-left:18px;
                    float:left;
                    font-weight: 400;
                    font-size: 20px;
                    color: #0F59A4;
                    text-align: center;
                    line-height: 45px;
                    cursor: pointer;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                }
            }
            // .smallRCZXList{
            //     width:calc(25% - 40px);
            //     height: 45px;
            //     line-height: 45px;
            //     background: #EEF8FF;
            //     box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            //     float:left;
            //     margin:0 20px;
            //     cursor:pointer;
            //     text-align: center;
            //     font-weight: 400;
            //     font-size: 22px;
            //     color: #0F59A4;
            // }
        }
        
    }


    .testContent{
        width:100%;
        box-sizing: border-box;
        padding:20px;
        overflow: hidden;
        background: #ffffff;
        .testListBox{
            width:100%;
            height:45px;
            .testNavListCheck{
                font-weight: 700;
                font-size: 20px;
                color: #FFFFFF!important;
                background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%)!important;
            }
            .testNavList{
                width: 148px;
                height: 45px;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                float:left;
                margin-right:18px;
                font-weight: 400;
                font-size: 20px;
                color: #0F59A4;
                text-align: center;
                line-height: 45px;
                cursor:pointer;
            }
        }
        .testListBorder{
            width: 810px;
            height: 3px;
            background: #0F59A4;
        }

        /**补贴检测 **/
        
        /**补贴检测 **/
    }
    /** 我的检测报告 end */
</style>